import React from "react";
import LegalShell from "../../components/root/LegalShell";
import Seo from "../../components/Seo";
import SEO from "../../seo/pages.json";
import { faqSchema } from "../../utils/structuredData";
import { GENERAL_FAQ } from "../../data/generalFaq";

export default function FAQ() {
  return (
    <LegalShell title="Frequently Asked Questions">
      <Seo
        {...SEO["/faq"]}
        path="/faq"
        jsonLd={[faqSchema(GENERAL_FAQ)]}
      />

      <div className="space-y-5">
        {GENERAL_FAQ.map((f) => (
          <div key={f.q}>
            <h2>{f.q}</h2>
            <p>{f.a}</p>
          </div>
        ))}
      </div>

      <p className="mt-4">
        Looking for Cabil Kids-specific questions (ages, safety, how the app works)? See the{" "}
        <a href="/kids/faq">Cabil Kids FAQ</a>.
      </p>
    </LegalShell>
  );
}
